import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../Context/AuthenticationContext';

export default function PrivateRoute() {
  const { isUserAuthenticated } = useAuth();
  const location = useLocation();

  return isUserAuthenticated() ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard" replace state={{ from: location }} />
  );
}
